<template>
    <div>
        <Header title="订单数据">
        </Header>
        <div style="display:flex">
            <div class="my-white-mod" style="margin-right:5px">
                <div class="mode-content">
                    <span class="mode-title">订单所属系统</span>                     
                    <DatePicker  :open="open_sys_month"  @on-change="changeSysMonth" confirm  format="yyyy-MM-dd" type="daterange" placement="bottom-end" placeholder="选择日期" style="width: 200px;margin-left: 12px;">
                        <span @click="sureSysMonth" class="pointer"><Icon type="md-calendar" size="20"  />                             
                            <template v-if="(search_sys.start_day == '' && search_sys.end_day == '' )" >                        
                                <span style="padding-left:8px">
                                    当月
                                </span>                        
                            </template>
                            <template v-else>{{ search_sys.start_day }}~ {{ search_sys.end_day }}</template>
                        </span>
                    </DatePicker> 
                    <Button @click="searchSys" type="warning" style="margin-left:10px">搜索</Button>
                    
                </div>
                <div style="padding:10px 20px;">
                    <Table  border :loading="sys_table.loading"   :columns="sys_table.columns" :data="sys_table.data"></Table>
                </div>   
            </div>
            
            <div class="my-white-mod" style="margin-left:5px">
                <div class="mode-content">
                    <span class="mode-title">订单所属客源</span>                     
                    <DatePicker  :open="open_ky_month"  @on-change="changeKyMonth" confirm  format="yyyy-MM-dd" type="daterange" placement="bottom-end" placeholder="选择日期" style="width: 200px;margin-left: 12px;">
                        <span @click="sureKyMonth" class="pointer"><Icon type="md-calendar" size="20"  />                             
                            <template v-if="(search_ky.start_day == '' && search_ky.end_day == '' )" >                        
                                <span style="padding-left:8px">
                                    当月
                                </span>                        
                            </template>
                            <template v-else>{{ search_ky.start_day }}~ {{ search_ky.end_day }}</template>
                        </span>
                    </DatePicker> 
                    <Button @click="searchSource" type="warning" style="margin-left:10px">搜索</Button>
                    
                </div>
                <div style="padding:10px 20px;">
                    <Table  border :loading="source_table.loading"   :columns="source_table.columns" :data="source_table.data"></Table>
                </div>            
            </div>
        </div>
        
       

    </div>

</template>
<script>
    
import {Header} from "@/components/mainLayout"
import {getCustomerSourceCount, getCustomerSysCount} from "@/api/statistics"
export default {
    components:{
        Header
    },
    data(){
        return{
            open_sys_month:false,
            search_sys:{
                start_day:'',
                end_day:''
            },
            open_ky_month:false,
            search_ky:{
                start_day:'',
                end_day:''
            },
            source_table:{
                loading:false,
                data:[],
                columns: [
                    {
                        title: '#',
                        width:"80",
                        align:'center',
                        type: 'index'
                    },
                    {
                        title: '金额',
                        align:'center',
                        sortable: true,
                        key: 'moneys'
                    },
                    {
                        title: '数量',
                        align:'center',
                        sortable: true,
                        key: 'nums'
                    },
                    {
                        title: '客源',
                        align:'center',
                        key: 'name'
                    }
                ]
            },
            sys_table:{
                loading:false,
                data:[],
                columns: [
                    {
                        title: '#',
                        width:"80",
                        align:'center',
                        type: 'index'
                    },
                    {
                        title: '金额',
                        align:'center',
                        sortable: true,
                        key: 'moneys'
                    },
                    {
                        title: '数量',
                        align:'center',
                        sortable: true,
                        key: 'nums'
                    },
                    {
                        title: '所属系统',
                        align:'center',
                        key: 'name'
                    }
                ]
            }
        }
    },
    mounted(){       
        this.getSourceCount()
        this.getSysCount()
    },
    methods:{
        changeSysMonth(e){
            if(e[0]){                
                this.search_sys.start_day = e[0]
                this.search_sys.end_day = e[1]
            }else{
                this.search_sys.start_day = ''
                this.search_sys.end_day = ''                
            }
            this.open_sys_month = false
        },
        sureSysMonth(){
            this.open_sys_month = !this.open_sys_month
        },
        
        changeKyMonth(e){
            if(e[0]){                
                this.search_ky.start_day = e[0]
                this.search_ky.end_day = e[1]
            }else{
                this.search_ky.start_day = ''
                this.search_ky.end_day = ''                
            }
            this.open_ky_month = false
        },
        sureKyMonth(){
            this.open_ky_month = !this.open_ky_month
        },
        getSourceCount(){
            getCustomerSourceCount(this.search_ky).then(res=>{
                this.source_table.data = res.data
            })
        },
        searchSource(){
            this.getSourceCount();
        },
        getSysCount(){
            getCustomerSysCount(this.search_sys).then(res=>{
                this.sys_table.data = res.data
            })
        },
        searchSys(){
            this.getSysCount();
        }
        
    }
}
</script>
<style>
    .my-white-mod{
        padding:10px 0;flex:1;
    }
    .mode-content{
        margin:10px 30px 0
    }
    .mode-title{
        font-weight: bold; font-size: 18px;
    }
</style>
